export default "__VITE_ASSET__a4ddd36c__"